//import axios from "axios";

import { GET_VIDEOS, VIDEOS_ERROR } from "./types";
import { firebase } from "../../firebase";

export const getVideos = () => async dispatch => {
  try {
    let db = firebase.firestore();
    db.settings({ timestampsInSnapshots: true });
    let videos = [];
    await db
      .collection("videos")
      .get()
      .then(querySnapshot1 => {
        querySnapshot1.docs.map(doc => {
          return videos.push({ id: doc.id, data: doc.data() });
        });
      });

    videos.sort((a, b) => {
      return new Date(b.data.date) - new Date(a.data.date);
    });

    dispatch({
      type: GET_VIDEOS,
      payload: videos
    });
  } catch (error) {
    dispatch({
      type: VIDEOS_ERROR,
      payload: error.message
    });
  }
};
